import { Box } from '@mui/material'
import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'
import { parseDayName } from '@utils/functions/parseDayName'

import type { HeaderWithDateProps } from './types'

export const HeaderWithDate = ({ item }: HeaderWithDateProps) => {
  return (
    <Box>
      {parseDayName(item.dia ?? '')}
      <Box sx={{ fontSize: '10px', fontWeight: 600 }}>{formattedDatePtBr(item.data) || ''}</Box>
    </Box>
  )
}
